import React,{FunctionComponent} from 'react'
import "external-svg-loader";
import {Container} from './style'
import config from "../../config/enviroment";
import Localization from '../WhatsAppChatWidget/localization.svg'

type TypesProps = {
  color: string,
  hover?: boolean,
  type: string,
  size?: string | null,
  width?: string,
  height?: string,
}

export const  CustomIcon:FunctionComponent<TypesProps> = ({type, color, hover = false, size=null, width='20px', height='20px' }) => {
  const iconComponent = () => {
    switch (type) {
      case 'localization':
        return <svg
          // data-src={`${config.urlMultimedia}/vende/landing-img/localization.svg`}
          data-src={Localization}
        />
      case 'share':
        return <svg
          data-src={`${config.urlMultimedia}/vende/landing-img/share.svg`}
        />
      case 'CartIcon':
        return <svg
          data-src={`${config.urlMultimedia}/vende/landing-img/CartIcon.svg`}
        />
      case 'warning':
        return <svg
          data-src={`${config.urlMultimedia}/vende/landing-img/warning.svg`}
          width={width} height={height}
        />
      case 'download':
        return <svg
          data-src={`${config.urlMultimedia}/vende/landing-img/hubDownload.svg`}
        />
      case 'printer' :
        return <svg
            data-src={`${config.urlMultimedia}/vende/landing-img/printer.svg`}
          />
      case 'money' :
        return <svg
            data-src={`${config.urlMultimedia}/vende/landing-img/money.svg`}
          />
      case 'user' :
        return <svg
            data-src={`${config.urlMultimedia}/vende/landing-img/User.svg`}
          />
      case 'contact' :
        return <svg
            data-src={`${config.urlMultimedia}/vende/landing-img/Contact.svg`}
          />
      case 'DeliveryTruckIcon':
        return <svg
            data-src={`${config.urlMultimedia}/vende/landing-img/entrega-gratis.svg`}
          />   
    }
      
  }
  return (
    <Container color={color} hover={hover} size={size}>
      {iconComponent()}
    </Container>
  )
}